import { reduxForm } from 'redux-form/immutable';

const PERSON_FORM = 'person_form';

const withReduxForm = reduxForm({
  form: PERSON_FORM,
});

export default withReduxForm;
